// import React, { useState, useEffect, useRef } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { Link, NavLink, useNavigate } from "react-router-dom";
// import axiosInstance from "../api/axios";
// import logo from "../images/logo.png";
// import TextField from "@mui/material/TextField";
// import Button from "@mui/material/Button";
// import { FaMessage } from "react-icons/fa6";
// import Navbarsmall from "./Navbarsmall";
// import { useAuth } from "./AuthContext";
// import { FaUserCircle } from "react-icons/fa";
// import ReactMarkdown from "react-markdown";
// import { useReactToPrint } from "react-to-print";

// // ─── Language → Voice mapping ─────────────────────────────────────────────────
// const languageVoiceMap = {
//   english:    { lang: "en-US" },
//   hindi:      { lang: "hi-IN" },
//   chinese:    { lang: "zh-CN" },
//   spanish:    { lang: "es-ES" },
//   japanese:   { lang: "ja-JP" },
//   french:     { lang: "fr-FR" },
//   russian:    { lang: "ru-RU" },
//   german:     { lang: "de-DE" },
//   telugu:     { lang: "te-IN" },
//   urdu:       { lang: "ur-PK" },
//   farsi:      { lang: "fa-IR" },
//   arabic:     { lang: "ar-SA" },
//   bengali:    { lang: "bn-IN" },
//   portuguese: { lang: "pt-PT" },
//   vietnamese: { lang: "vi-VN" },
//   korean:     { lang: "ko-KR" },
// };

// // ─── Shared ReactMarkdown components ──────────────────────────────────────────
// const mdComponents = {
//   h1: ({ children }) => <h1 className="text-3xl font-bold text-black mt-8 mb-4 tracking-tight">{children}</h1>,
//   h2: ({ children }) => <h2 className="text-2xl font-bold text-black mt-10 mb-4 pb-3 border-b border-gray-200">{children}</h2>,
//   h3: ({ children }) => <h3 className="text-xl font-semibold text-black mt-6 mb-3">{children}</h3>,
//   h4: ({ children }) => <h4 className="text-lg font-semibold text-black mt-5 mb-2 uppercase tracking-wide">{children}</h4>,
//   p:  ({ children }) => <p className="text-black text-base leading-8 mb-5">{children}</p>,
//   ul: ({ children, depth }) => <ul className={`mb-4 space-y-2.5 ${depth === 0 ? "pl-0" : "pl-5 mt-2"}`}>{children}</ul>,
//   ol: ({ children }) => <ol className="list-decimal list-outside pl-6 mb-5 space-y-2.5 text-black text-base">{children}</ol>,
//   li: ({ children, ordered }) => (
//     <li className="flex items-start gap-3 text-base text-black leading-7">
//       {!ordered && <span className="mt-2.5 h-2 w-2 rounded-full bg-black shrink-0" />}
//       <span className="flex-1">{children}</span>
//     </li>
//   ),
//   strong:     ({ children }) => <strong className="font-semibold text-black">{children}</strong>,
//   em:         ({ children }) => <em className="italic text-black">{children}</em>,
//   blockquote: ({ children }) => <blockquote className="border-l-4 border-gray-300 bg-gray-50 pl-5 pr-4 py-4 my-5 rounded-r-xl text-base text-black leading-8">{children}</blockquote>,
//   hr:   () => <hr className="border-gray-100 my-8" />,
//   code: ({ children }) => <code className="bg-gray-100 text-black px-2 py-1 rounded text-sm font-mono">{children}</code>,
// };

// // ─── Print-only styled report component ───────────────────────────────────────
// const PrintableReport = React.forwardRef(({ title, content }, ref) => (
//   <div ref={ref}>
//     <style>{`
//       @media print {
//         @page { margin: 40px; }
//         body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
//       }
//     `}</style>
//     <div style={{ fontFamily: "'Poppins', sans-serif", padding: "40px", maxWidth: "800px", margin: "0 auto" }}>
//       {/* Header */}
//       <div style={{
//         display: "flex", flexDirection: "column", alignItems: "center",
//         marginBottom: "32px", borderBottom: "2px solid #967d6c", paddingBottom: "24px",
//       }}>
//         <img src={logo} alt="Furbabies.AI" style={{ height: "72px", marginBottom: "12px", objectFit: "contain" }} />
//         <h1 style={{ fontSize: "22px", fontWeight: "700", color: "#333", margin: 0, textAlign: "center" }}>{title}</h1>
//         <p style={{ fontSize: "11px", color: "#aaa", marginTop: "8px", textAlign: "center" }}>
//           Generated by Furbabies.AI · For general educational purposes only · Not a substitute for professional nutritional advice
//         </p>
//       </div>

//       {/* Markdown content */}
//       <ReactMarkdown components={mdComponents}>{content}</ReactMarkdown>

//       {/* Footer */}
//       <div style={{
//         marginTop: "48px", borderTop: "1px solid #e0d5ce", paddingTop: "16px",
//         fontSize: "10px", color: "#000", textAlign: "center", lineHeight: "1.6",
//       }}>
//         Furbabies.AI<br />
//         This report is for general educational and informational purposes only. It does not constitute veterinary nutritional
//         advice or a prescribed diet. Individual animals have unique dietary needs — always consult a licensed veterinarian or
//         board-certified veterinary nutritionist before making changes to your pet's diet.
//       </div>
//     </div>
//   </div>
// ));

// // ─── Strip markdown for TTS ───────────────────────────────────────────────────
// const stripMarkdown = (text) =>
//   text
//     .replace(/#{1,6}\s+/g, "")
//     .replace(/\*{1,3}([^*]+)\*{1,3}/g, "$1")
//     .replace(/`{1,3}[^`]*`{1,3}/g, "")
//     .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
//     .replace(/!\[[^\]]*\]\([^)]+\)/g, "")
//     .replace(/^[-*_]{3,}\s*$/gm, "")
//     .replace(/^>\s+/gm, "")
//     .replace(/^[-*+]\s+/gm, "")
//     .replace(/^\d+\.\s+/gm, "")
//     .replace(/\|/g, " ")
//     .replace(/\n{2,}/g, ". ")
//     .replace(/\n/g, " ")
//     .replace(/\s{2,}/g, " ")
//     .trim();

// const speakText = (text, selectedLanguage, onEnd) => {
//   window.speechSynthesis.cancel();
//   const cleaned = stripMarkdown(text);
//   const { lang } = languageVoiceMap[selectedLanguage] || languageVoiceMap.english;

//   const doSpeak = (voices) => {
//     const langBase = lang.split("-")[0];
//     const matched =
//       voices.find((v) => v.lang === lang) ||
//       voices.find((v) => v.lang.startsWith(langBase)) ||
//       voices.find((v) => v.lang.toLowerCase().startsWith(langBase.toLowerCase())) ||
//       null;

//     const speech = new SpeechSynthesisUtterance(cleaned);
//     if (matched) { speech.voice = matched; speech.lang = matched.lang; }
//     else { speech.lang = lang; }
//     speech.rate   = 1.0;
//     speech.pitch  = 1.0;
//     speech.onend  = onEnd;
//     speech.onerror = onEnd;
//     window.speechSynthesis.speak(speech);
//     return true;
//   };

//   const voices = window.speechSynthesis.getVoices();
//   if (voices.length > 0) return doSpeak(voices);
//   window.speechSynthesis.onvoiceschanged = () => {
//     window.speechSynthesis.onvoiceschanged = null;
//     doSpeak(window.speechSynthesis.getVoices());
//   };
//   return true;
// };

// // ─── Small reusable action button ─────────────────────────────────────────────
// const ActionBtn = ({ onClick, disabled, children, title }) => (
//   <motion.button
//     title={title}
//     whileHover={!disabled ? { backgroundColor: "#BDA697" } : {}}
//     whileTap={!disabled ? { backgroundColor: "#7a6457" } : {}}
//     onClick={!disabled ? onClick : undefined}
//     className={`flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-medium shadow-sm transition-colors
//       ${disabled ? "bg-gray-300 text-white cursor-not-allowed" : "bg-[#967d6c] text-white cursor-pointer"}`}
//   >
//     {children}
//   </motion.button>
// );

// const IconPdf = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
//     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 7V3.5L18.5 9H13zM8 17v-2h8v2H8zm0-4v-2h8v2H8z"/>
//   </svg>
// );

// // ─── Disclaimer sections data ──────────────────────────────────────────────────
// const disclaimerSections = [
//   { heading: "Educational Purposes Only", body: "This analysis is provided for general educational and informational purposes only. It is not intended to constitute, and should not be relied upon as, veterinary medical advice, diagnosis, treatment, or a substitute for professional veterinary care." },
//   { heading: "No Veterinary Relationship Formed", body: "No veterinarian-client-patient relationship (VCPR) is established through the use of this tool. A valid VCPR requires a licensed veterinarian to have sufficient knowledge of your animal through a physical, in-person examination and an ongoing relationship — neither of which this tool provides." },
//   { heading: "Individual Animal Needs Vary", body: "All nutritional information, meal suggestions, supplement recommendations, and feeding guidance are general in nature. Individual animals have unique health profiles, medical histories, breed-specific needs, and conditions that may make general guidance inappropriate or unsafe. Always consult a licensed veterinarian or board-certified veterinary nutritionist (DACVN) before making changes to your pet's diet." },
//   { heading: "Home-Prepared Meals", body: "Home-prepared meals can be a wholesome and healthy choice for your pet when done correctly. However, achieving complete and balanced nutrition at home requires careful planning. Without the right combination of ingredients and supplements, nutritional gaps can develop over time. Always work with a board-certified veterinary nutritionist to ensure any home-prepared diet fully meets your pet's individual needs." },
//   { heading: "Ingredient Safety", body: "Ingredient safety information is provided for general guidance only. Individual animals may have allergies, intolerances, or conditions that make otherwise safe ingredients unsuitable for them. Toxic ingredient warnings reflect currently available knowledge and may not be exhaustive." },
//   { heading: "Limitation of Liability", body: "Furbabies.AI expressly disclaims all liability for any adverse health outcomes, injury, illness, loss, or harm to any animal arising from reliance on the information provided. Use of this tool is entirely at your own risk." },
//   { heading: "Medical Emergencies", body: "This tool is not intended for use in medical emergencies. If your pet is experiencing a medical emergency, contact your nearest emergency veterinary hospital immediately or call the ASPCA Animal Poison Control Center or the Pet Poison Helpline if poisoning is suspected." },
//   { body: "By using Furbabies.AI, you acknowledge that you have read, understood, and agree to the terms of this disclaimer." },
// ];

// const PetNutrition = () => {
//   const [image, setImage]                         = useState(null);
//   const [imageUploaded, setImageUploaded]         = useState(false);
//   const [imagePreviewUrl, setImagePreviewUrl]     = useState("");
//   const [analysis, setAnalysis]                   = useState("");
//   const [animalType, setAnimalType]               = useState("dog");
//   const [loading, setLoading]                     = useState(false);
//   const [error, setError]                         = useState("");
//   const [targetLanguage, setTargetLanguage]       = useState("english");
//   const [question, setQuestion]                   = useState("");
//   const [isImageExpanded, setIsImageExpanded]     = useState(false);
//   const [isBotReplying, setIsBotReplying]         = useState(false);
//   const [isChatOpen, setIsChatOpen]               = useState(false);
//   const [isDisclaimerOpen, setIsDisclaimerOpen]   = useState(false);
//   const [isSpeaking, setIsSpeaking]               = useState(false);
//   const [isListening, setIsListening]             = useState(false);
//   const [latestAnalysis, setLatestAnalysis]       = useState({ content: "" });
//   const [referenceAnalysis, setReferenceAnalysis] = useState(false);

//   // ── Print ref ─────────────────────────────────────────────────────────────
//   const mealReportRef = useRef(null);

//   const handlePrintMeal = useReactToPrint({
//     contentRef: mealReportRef,
//     documentTitle: "Furbabies — Pet Nutrition Meal Report",
//   });

//   const [chatHistory, setChatHistory] = useState([
//     {
//       type: "answer",
//       content: "Ask me anything about your pet's health, nutrition, or behavior — the more specific you are, the better I can help.\n\n**Disclaimer:** This chat is for general educational purposes only. It does not constitute veterinary medical advice, diagnosis, or treatment, and does not establish a veterinarian-client-patient relationship (VCPR). Never disregard or delay professional veterinary care based on anything discussed here. If your pet is experiencing a medical emergency, contact your nearest emergency veterinary hospital immediately or call the Animal Poison Control Center for suspected poisoning. Use of this chat is entirely at your own risk.",
//     },
//   ]);

//   const { logout } = useAuth();
//   const navigate   = useNavigate();

//   const handleLogout = () => { logout(); navigate("/"); };

//   useEffect(() => {
//     const stop = () => { window.speechSynthesis.cancel(); setIsSpeaking(false); };
//     window.addEventListener("beforeunload", stop);
//     return () => window.removeEventListener("beforeunload", stop);
//   }, []);

//   useEffect(() => {
//     if (window.performance && window.performance.navigation.type === 1) {
//       const clearConversation = async () => {
//         const sessionId = localStorage.getItem("sessionId");
//         try { await axiosInstance.post("/clear_conversation", { sessionId }); }
//         catch (e) { console.error("Error clearing conversation:", e); }
//       };
//       clearConversation();
//     }
//   }, []);

//   const handleImageUpload = (event) => {
//     const file = event.target.files[0];
//     setImageUploaded(true);
//     if (file) {
//       setImage(file);
//       setImagePreviewUrl(URL.createObjectURL(file));
//     }
//   };

//   const handleLanguageChange  = (e) => setTargetLanguage(e.target.value);
//   const handleAnimalTypeChange = (e) => setAnimalType(e.target.value);

//   const handleSubmit = async () => {
//     if (!image) { setError("Please upload an image."); return; }
//     const formData = new FormData();
//     const sessionId = localStorage.getItem("sessionId");
//     formData.append("image", image);
//     formData.append("animal_type", animalType);
//     formData.append("target_language", targetLanguage);
//     setLoading(true); setError(""); setAnalysis("");
//     try {
//       const response = await axiosInstance.post(`/analyze/${animalType}_food/`, formData,{
//         headers: {
//           "X-Session-ID": sessionId,
//         },
//       });
//       setIsImageExpanded(true);
//       setAnalysis(response.data.analysis);
//       setLatestAnalysis({ content: response.data.analysis });
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to analyze the image. Please try again.");
//     } finally { setLoading(false); }
//   };

//   const handleToggleReadAloud = () => {
//     if (isSpeaking) { window.speechSynthesis.cancel(); setIsSpeaking(false); return; }
//     if (!analysis) return;
//     const started = speakText(analysis, targetLanguage, () => setIsSpeaking(false));
//     if (started) setIsSpeaking(true);
//   };

//   const recognitionRef = React.useRef(null);

//   const handleQuestionChange = (e) => setQuestion(e.target.value);

//   const handleAskQuestion = async () => {
//     const sessionId = localStorage.getItem("sessionId");
//     if (question.trim() === "") return;
//     setChatHistory((prev) => [...prev, { type: "question", content: question }]);
//     setIsBotReplying(true);

//     const analysisContext =
//       referenceAnalysis && latestAnalysis.content
//         ? `[Meal Analysis Context]\n${stripMarkdown(latestAnalysis.content)}`
//         : "";

//     try {
//       const response = await axiosInstance.post("/ask", {
//         question, target_language: targetLanguage, sessionId,
//         ...(analysisContext && { analysis_context: analysisContext }),
//       });
//       setChatHistory((prev) => [...prev, { type: "answer", content: response.data.answer }]);
//     } catch {
//       setChatHistory((prev) => [...prev, { type: "answer", content: "An error occurred while fetching the answer." }]);
//     }
//     setIsBotReplying(false);
//     setQuestion("");
//   };

//   const toggleChat = () => setIsChatOpen(!isChatOpen);

//   return (
//     <>
//       {/* ── Hidden printable report target ── */}
//       <div style={{ display: "none" }}>
//         <PrintableReport
//           ref={mealReportRef}
//           title="Furbaby's Meal Plan"
//           content={analysis}
//         />
//       </div>

//       {/* ── Main app wrapper ── */}
//       <div className="flex h-screen">
//         <span className="block xl:hidden"><Navbarsmall /></span>

//         {/* ── Sidebar ── */}
//         <motion.nav className="fixed top-0 left-0 h-full w-1/8 md:w-1/8 bg-[#E8E1DA] space-y-8 z-50 xl:block hidden">
//           <div className="text-4xl font-bold text-center text-gray-800">
//             <a href="/" target="_blank" rel="noopener noreferrer">
//               <img src={logo} alt="Logo" className="w-44 h-44 mx-auto" />
//             </a>
//           </div>
//           <motion.ul className="text-[#967d6c] font-semibold">
//             <motion.li className="w-full">
//               <NavLink to="/furhome" className={({ isActive }) =>
//                 isActive ? "bg-[#967d6c] text-white w-full px-4 pt-3 pb-4 text-xl block"
//                          : "hover:bg-[#bda697] w-full px-4 pt-3 pb-4 text-xl block"}>
//                 Home
//               </NavLink>
//             </motion.li>
//             <motion.li>
//               <NavLink to="/pet-health" className={({ isActive }) =>
//                 isActive ? "bg-[#967d6c] text-white w-full px-4 pt-3 pb-4 text-xl block"
//                          : "hover:bg-[#bda697] w-full px-4 pt-3 pb-4 text-xl block"}>
//                 Pet Health
//               </NavLink>
//             </motion.li>
//             <motion.li>
//               <NavLink to="/pet-nutrition" className={({ isActive }) =>
//                 isActive ? "bg-[#967d6c] text-white w-full px-4 pt-3 pb-4 text-xl block"
//                          : "hover:bg-[#bda697] w-full px-4 pt-3 pb-4 text-xl block"}>
//                 Pet Nutrition
//               </NavLink>
//             </motion.li>
//           </motion.ul>
//           <div className="absolute bottom-0 w-full pb-2">
//             <button
//               onClick={() => setIsDisclaimerOpen(true)}
//               className="hover:bg-[#bda697] text-[#8b6145] w-full px-4 py-2 text-md bg-transparent focus:outline-none text-center block opacity-100 hover:opacity-100 transition-opacity">
//               Disclaimer
//             </button>
//             <NavLink to="#" onClick={handleLogout}
//               className="hover:text-gray-800 poppins-text text-[#967d6c] w-full px-4 py-2 text-xl bg-transparent focus:outline-none text-center block">
//               Logout
//             </NavLink>
//           </div>
//         </motion.nav>

//         {/* ── Profile icon ── */}
//         <div className="absolute top-20 xl:block hidden right-16 z-50">
//           <Link to="/account">
//             <motion.div className="text-5xl text-[#967d6c]" whileHover={{ scale: 1.2 }} transition={{ duration: 0.3 }}>
//               <FaUserCircle />
//             </motion.div>
//           </Link>
//         </div>

//         {/* ── Main content ── */}
//         <div className="flex-auto bg-white xl:mt-8 mt-24 p-8">
//           <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }} className="max-w-4xl mx-auto">
//             <h1 className="text-5xl lg:text-[60px] lg:leading-[70px] mt-4 font-bold text-gray-800 mb-4">
//               Hungry Furbaby?
//             </h1>
//             <p className="text-gray-600 poppins-text text-xl lg:text-[20px] lg:leading-[28px] mb-8">
//               Take a picture of the food you have, and we will suggest a meal for your furbaby.
//             </p>

//             {/* Language + Animal selectors */}
//             <div className="mb-8 flex flex-wrap gap-4">
//               <div className="flex-0">
//                 <select id="language" value={targetLanguage} onChange={handleLanguageChange}
//                   className="block text-lg lg:text-[20px] poppins-text lg:leading-[26px] px-4 py-2 border border-[#BDA697] rounded-full">
//                   {["English","Hindi","Chinese","Spanish","Japanese","French","Russian","German",
//                     "Telugu","Urdu","Farsi","Arabic","Bengali","Portuguese","Vietnamese","Korean"
//                   ].map((lang) => (
//                     <option key={lang.toLowerCase()} value={lang.toLowerCase()}>{lang}</option>
//                   ))}
//                 </select>
//               </div>
//               <div className="flex-1">
//                 <select id="animalType" value={animalType} onChange={handleAnimalTypeChange}
//                   className="block text-xl lg:text-[20px] lg:leading-[26px] poppins-text px-4 py-2 border border-[#BDA697] rounded-full">
//                   <option value="dog">Dog</option>
//                   <option value="cat">Cat</option>
//                 </select>
//               </div>
//             </div>

//             {/* Upload + Submit */}
//             <div className="flex space-x-4 mb-8">
//               <label htmlFor="upload" className="cursor-pointer">
//                 <motion.span whileHover={{ backgroundColor: "#BDA697" }} whileTap={{ backgroundColor: "#967d6c" }}
//                   className="inline-block bg-[#967d6c] text-white text-lg lg:text-[20px] lg:leading-[26px] lg:px-12 lg:py-4 px-6 py-2 rounded-full shadow-md">
//                   Upload a Photo
//                 </motion.span>
//                 <input id="upload" type="file" accept="image/*" className="hidden" onChange={handleImageUpload} />
//               </label>
//               <motion.button
//                 onClick={handleSubmit}
//                 whileHover={imageUploaded && !loading ? { backgroundColor: "#BDA697" } : {}}
//                 whileTap={imageUploaded && !loading ? { backgroundColor: "#967d6c" } : {}}
//                 className={`lg:px-12 lg:py-4 px-6 py-2 text-lg lg:text-[20px] lg:leading-[26px] rounded-full shadow-md ${
//                   loading ? "bg-gray-400 text-white shadow-none"
//                   : imageUploaded ? "bg-[#967d6c] text-white"
//                   : "bg-gray-400 text-white shadow-none"
//                 }`}>
//                 {loading ? "Generating Meal..." : "Suggest Meal"}
//               </motion.button>
//             </div>

//             {error && <p className="text-red-500 mt-4 poppins-text text-xl">{error}</p>}

//             {imagePreviewUrl && (
//               <div className="mt-8">
//                 <img src={imagePreviewUrl} alt="Uploaded Preview" className="w-60 max-w-md h-auto object-contain rounded-lg" />
//               </div>
//             )}

//             {loading && (
//               <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} className="flex justify-center items-center mt-4">
//                 <div className="flex justify-center items-center mt-4">
//                   <div className="w-8 h-8 border-4 border-b-transparent border-[#8B5E3C] rounded-full animate-spin" />
//                   <p className="text-[#8B5E3C] poppins-text ml-2">Generating Meal...</p>
//                 </div>
//               </motion.div>
//             )}

//             {/* ── Analysis result ── */}
//             <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }} className="mt-8 pb-4">
//               <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
//                 <h2 className="text-3xl font-bold text-gray-800">Furbaby's Meal</h2>
//                 <div className="flex items-center gap-2 flex-wrap">
//                   <ActionBtn onClick={handleToggleReadAloud} disabled={!analysis} title="Read meal plan aloud">
//                     {isSpeaking ? (
//                       <>
//                         <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
//                           <rect x="6" y="4" width="4" height="16" rx="1" /><rect x="14" y="4" width="4" height="16" rx="1" />
//                         </svg>
//                         Stop
//                       </>
//                     ) : (
//                       <>
//                         <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
//                           <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
//                         </svg>
//                         Read Aloud
//                       </>
//                     )}
//                   </ActionBtn>

//                   <ActionBtn onClick={handlePrintMeal} disabled={!analysis} title="Save meal plan as PDF">
//                     <IconPdf /> Save as PDF
//                   </ActionBtn>

//                   <Button variant="outlined" onClick={() => setIsImageExpanded(!isImageExpanded)} style={{ backgroundColor: "#967d6c", color: "white" }}>
//                     {isImageExpanded ? "Minimize" : "Expand"}
//                   </Button>
//                 </div>
//               </div>

//               <motion.div
//                 animate={{ height: isImageExpanded ? "calc(100vh - 400px)" : "300px" }}
//                 transition={{ duration: 0.3 }}
//                 className="w-full poppins-text text-lg p-4 mb-6 border border-gray-300 rounded-lg overflow-y-auto shadow-sm resize-none bg-white">
//                 {analysis
//                   ? <ReactMarkdown components={mdComponents}>{analysis}</ReactMarkdown>
//                   : <span className="text-gray-400">We're here to help, just upload an image!</span>
//                 }
//               </motion.div>
//             </motion.div>
//           </motion.div>
//         </div>

//         {/* ── Chat toggle button ── */}
//         <div className="fixed bottom-5 right-5 bg-transparent cursor-pointer bg-[#ffffff] text-white rounded-full p-6 group" onClick={toggleChat}>
//           <div className="absolute -left-[14rem] hidden xl:block top-1/2 -translate-y-1/2 bg-[#b89a8c] text-white text-md rounded-lg px-3 py-2 shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
//             Ask your personal Furbot!
//           </div>
//           <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="relative flex items-center bg-transparent justify-center w-16 h-16 bg-[#ffffff] rounded-lg">
//             <FaMessage className="w-20 h-20 text-[#e8e1da]" />
//             <img src="../images/FurbotFilled.svg" alt="Furbot Icon" className="absolute bottom-5 w-10 h-10" />
//           </motion.div>
//         </div>

//         {/* ── Chat panel ── */}
//         {isChatOpen && (
//           <motion.div
//             initial={{ opacity: 0, scale: 0.8, y: 20 }}
//             animate={{ opacity: 1, scale: 1, y: 0 }}
//             exit={{ opacity: 0, scale: 0.8, y: 20 }}
//             transition={{ type: "spring", stiffness: 300, damping: 30 }}
//             className="fixed bottom-36 right-5 bg-white border border-gray-200 rounded-2xl shadow-2xl w-[22rem] md:w-[32rem] flex flex-col"
//             style={{ maxHeight: "75vh" }}
//           >
//             <div className="p-4 bg-[#967d6c] text-white rounded-t-2xl flex items-center justify-between flex-shrink-0">
//               <div className="flex items-center gap-3">
//                 <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
//                   <img src="../images/Furbot.svg" alt="Furbot Icon" className="h-6 w-6 filter invert" />
//                 </div>
//                 <div>
//                   <h3 className="text-xl font-bold leading-tight">Furbot</h3>
//                   <p className="text-xs text-white/75">Your personal pet health assistant</p>
//                 </div>
//               </div>
//               <motion.button whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} onClick={toggleChat}
//                 className="w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//                   <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//               </motion.button>
//             </div>

//             {latestAnalysis.content && (
//               <div className="px-4 py-2.5 bg-[#f7f1eb] border-b border-[#e8ddd6] flex items-center justify-between flex-shrink-0">
//                 <div className="flex items-center gap-2">
//                   <div className={`w-2 h-2 rounded-full ${referenceAnalysis ? "bg-green-500" : "bg-gray-300"}`} />
//                   <span className="text-sm poppins-text text-gray-700 font-medium">
//                     Reference my <span className="text-[#967d6c] font-semibold">meal analysis</span>
//                   </span>
//                 </div>
//                 <button onClick={() => setReferenceAnalysis((prev) => !prev)}
//                   className={`relative inline-flex w-11 h-6 rounded-full transition-colors duration-200 focus:outline-none flex-shrink-0 ${referenceAnalysis ? "bg-[#967d6c]" : "bg-gray-300"}`}>
//                   <span className={`inline-block w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200 mt-0.5 ${referenceAnalysis ? "translate-x-5" : "translate-x-0.5"}`} />
//                 </button>
//               </div>
//             )}

//             <div className="flex-1 overflow-y-auto p-4 space-y-3 min-h-0">
//               {chatHistory.map((msg, index) => (
//                 <div key={index} className={`flex items-start gap-2 ${msg.type === "question" ? "flex-row-reverse" : "flex-row"}`}>
//                   <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-white ${msg.type === "question" ? "bg-[#967d6c]" : "bg-[#bda697]"}`}>
//                     {msg.type === "question" ? "U" : <img src="../images/Furbot.svg" alt="FB" className="h-4 w-4 filter invert" />}
//                   </div>
//                   <div className={`max-w-[78%] px-3.5 py-2.5 rounded-2xl text-sm poppins-text leading-relaxed ${
//                     msg.type === "question" ? "bg-[#967d6c] text-white rounded-tr-sm" : "bg-gray-100 text-gray-800 rounded-tl-sm"
//                   }`}>{msg.content}</div>
//                 </div>
//               ))}
//               {isBotReplying && (
//                 <div className="flex items-center gap-2">
//                   <div className="w-8 h-8 rounded-full bg-[#bda697] flex items-center justify-center flex-shrink-0">
//                     <img src="../images/Furbot.svg" alt="FB" className="h-4 w-4 filter invert" />
//                   </div>
//                   <div className="bg-gray-100 px-4 py-3 rounded-2xl rounded-tl-sm flex items-center gap-1.5">
//                     <span className="w-2 h-2 bg-[#967d6c] rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
//                     <span className="w-2 h-2 bg-[#967d6c] rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
//                     <span className="w-2 h-2 bg-[#967d6c] rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="p-3 border-t border-gray-100 flex-shrink-0 bg-white rounded-b-2xl">
//               <TextField
//                 variant="outlined" size="small" fullWidth multiline maxRows={3}
//                 value={question} onChange={handleQuestionChange}
//                 placeholder="Ask Furbot about your pet's meal…"
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     borderRadius: "12px", backgroundColor: "#f7f1eb", fontSize: "0.875rem",
//                     "& fieldset": { borderColor: "#e0d4cc" },
//                     "&:hover fieldset": { borderColor: "#967d6c" },
//                     "&.Mui-focused fieldset": { borderColor: "#967d6c" },
//                   },
//                 }}
//                 onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleAskQuestion(); } }}
//               />
//               <div className="mt-2">
//                 <button
//                   onClick={handleAskQuestion}
//                   disabled={isBotReplying || question.trim() === ""}
//                   className={`w-full py-2 rounded-xl text-white text-sm font-semibold transition-colors ${
//                     isBotReplying || question.trim() === "" ? "bg-gray-300 cursor-not-allowed" : "bg-[#967d6c]"
//                   }`}>
//                   {isBotReplying ? "Sending..." : "Send"}
//                 </button>
//               </div>
//               {isListening && (
//                 <p className="text-xs text-[#967d6c] poppins-text mt-1.5 text-center animate-pulse">
//                   🎙 Listening in {targetLanguage}…
//                 </p>
//               )}
//               {referenceAnalysis && latestAnalysis.content && (
//                 <p className="text-xs text-green-600 poppins-text mt-1 text-center">
//                   ✓ Meal analysis will be sent as context
//                 </p>
//               )}
//             </div>
//           </motion.div>
//         )}
//       </div>

//       {/* ── Disclaimer Modal ── */}
//       <AnimatePresence>
//         {isDisclaimerOpen && (
//           <>
//             <motion.div
//               initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
//               onClick={() => setIsDisclaimerOpen(false)}
//               style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.4)", zIndex: 200 }}
//             />
//             <div style={{ position: "fixed", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 201, pointerEvents: "none" }}>
//               <motion.div
//                 initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }}
//                 transition={{ duration: 0.25 }}
//                 style={{ pointerEvents: "all" }}
//                 className="flex flex-col bg-[#F5F0EB] rounded-2xl shadow-2xl w-[min(90vw,640px)] max-h-[75vh]"
//               >
//                 <div className="flex items-center justify-between px-7 py-5 border-b border-[#d4c4b8] shrink-0">
//                   <h2 className="text-xl font-bold text-gray-800">Pet Nutrition Disclaimer</h2>
//                   <button onClick={() => setIsDisclaimerOpen(false)}
//                     className="text-[#967d6c] hover:text-gray-800 transition-colors text-3xl leading-none font-light w-8 h-8 flex items-center justify-center">
//                     ×
//                   </button>
//                 </div>
//                 <div className="overflow-y-auto px-7 py-6 space-y-6 flex-1">
//                   {disclaimerSections.map((section, i) => (
//                     <div key={i} className="border-l-4 border-[#967d6c] pl-4">
//                       <h3 className="font-bold text-gray-800 mb-1 text-sm">{section.heading}</h3>
//                       <p className="text-gray-600 text-sm leading-relaxed">{section.body}</p>
//                     </div>
//                   ))}
//                 </div>
//                 <div className="px-7 py-4 border-t border-[#d4c4b8] shrink-0">
//                   <button onClick={() => setIsDisclaimerOpen(false)}
//                     className="w-full py-2 bg-[#967d6c] text-white font-semibold rounded-lg hover:bg-[#bda697] transition-colors text-sm">
//                     I Understand
//                   </button>
//                 </div>
//               </motion.div>
//             </div>
//           </>
//         )}
//       </AnimatePresence>
//     </>
//   );
// };

// export default PetNutrition;

import React, { useState, useEffect, useRef, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link, NavLink, useNavigate } from "react-router-dom";
import axiosInstance from "../api/axios";
import logo from "../images/logo.png";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { FaMessage } from "react-icons/fa6";
import Navbarsmall from "./Navbarsmall";
import { useAuth } from "./AuthContext";
import { FaUserCircle } from "react-icons/fa";
import ReactMarkdown from "react-markdown";
import chatMdComponents from "./chatMdComponents";
import { useReactToPrint } from "react-to-print";

// ─── Language → Voice mapping ─────────────────────────────────────────────────
const languageVoiceMap = {
  english:    { lang: "en-US" },
  hindi:      { lang: "hi-IN" },
  chinese:    { lang: "zh-CN" },
  spanish:    { lang: "es-ES" },
  japanese:   { lang: "ja-JP" },
  french:     { lang: "fr-FR" },
  russian:    { lang: "ru-RU" },
  german:     { lang: "de-DE" },
  telugu:     { lang: "te-IN" },
  urdu:       { lang: "ur-PK" },
  farsi:      { lang: "fa-IR" },
  arabic:     { lang: "ar-SA" },
  bengali:    { lang: "bn-IN" },
  portuguese: { lang: "pt-PT" },
  vietnamese: { lang: "vi-VN" },
  korean:     { lang: "ko-KR" },
};

const ALL_LANGUAGES = [
  "english", "hindi", "chinese", "spanish", "japanese", "french",
  "russian", "german", "telugu", "urdu", "farsi", "arabic",
  "bengali", "portuguese", "vietnamese", "korean",
];

// ─── Shared ReactMarkdown components ──────────────────────────────────────────
const mdComponents = {
  h1: ({ children }) => <h1 className="text-3xl font-bold text-black mt-8 mb-4 tracking-tight">{children}</h1>,
  h2: ({ children }) => <h2 className="text-2xl font-bold text-black mt-10 mb-4 pb-3 border-b border-gray-200">{children}</h2>,
  h3: ({ children }) => <h3 className="text-xl font-semibold text-black mt-6 mb-3">{children}</h3>,
  h4: ({ children }) => <h4 className="text-lg font-semibold text-black mt-5 mb-2 uppercase tracking-wide">{children}</h4>,
  p:  ({ children }) => <p className="text-black text-base leading-8 mb-5">{children}</p>,
  ul: ({ children, depth }) => <ul className={`mb-4 space-y-2.5 ${depth === 0 ? "pl-0" : "pl-5 mt-2"}`}>{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal list-outside pl-6 mb-5 space-y-2.5 text-black text-base">{children}</ol>,
  li: ({ children, ordered }) => (
    <li className="flex items-start gap-3 text-base text-black leading-7">
      {!ordered && <span className="mt-2.5 h-2 w-2 rounded-full bg-black shrink-0" />}
      <span className="flex-1">{children}</span>
    </li>
  ),
  strong:     ({ children }) => <strong className="font-semibold text-black">{children}</strong>,
  em:         ({ children }) => <em className="italic text-black">{children}</em>,
  blockquote: ({ children }) => (
    <blockquote className="border-l-4 border-gray-300 bg-gray-50 pl-5 pr-4 py-4 my-5 rounded-r-xl text-base text-black leading-8">
      {children}
    </blockquote>
  ),
  hr:   () => <hr className="border-gray-100 my-8" />,
  code: ({ children }) => (
    <code className="bg-gray-100 text-black px-2 py-1 rounded text-sm font-mono">{children}</code>
  ),
};

// ─── Print-only styled report component ───────────────────────────────────────
const PrintableReport = React.forwardRef(({ title, content }, ref) => (
  <div ref={ref}>
    <style>{`
      @media print {
        @page { margin: 40px; }
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    `}</style>
    <div style={{ fontFamily: "'Poppins', sans-serif", padding: "40px", maxWidth: "800px", margin: "0 auto" }}>
      <div style={{
        display: "flex", flexDirection: "column", alignItems: "center",
        marginBottom: "32px", borderBottom: "2px solid #967d6c", paddingBottom: "24px",
      }}>
        <img src={logo} alt="Furbabies.AI" style={{ height: "72px", marginBottom: "12px", objectFit: "contain" }} />
        <h1 style={{ fontSize: "22px", fontWeight: "700", color: "#333", margin: 0, textAlign: "center" }}>{title}</h1>
        <p style={{ fontSize: "11px", color: "#aaa", marginTop: "8px", textAlign: "center" }}>
          Generated by Furbabies.AI · For general educational purposes only · Not a substitute for professional nutritional advice
        </p>
      </div>
      <ReactMarkdown components={mdComponents}>{content}</ReactMarkdown>
      <div style={{
        marginTop: "48px", borderTop: "1px solid #e0d5ce", paddingTop: "16px",
        fontSize: "10px", color: "#000", textAlign: "center", lineHeight: "1.6",
      }}>
        Furbabies.AI<br />
        This report is for general educational and informational purposes only. It does not constitute veterinary nutritional
        advice or a prescribed diet. Individual animals have unique dietary needs — always consult a licensed veterinarian or
        board-certified veterinary nutritionist before making changes to your pet's diet.
      </div>
    </div>
  </div>
));

// ─── Strip markdown for TTS ───────────────────────────────────────────────────
const stripMarkdown = (text) =>
  text
    .replace(/#{1,6}\s+/g, "")
    .replace(/\*{1,3}([^*]+)\*{1,3}/g, "$1")
    .replace(/`{1,3}[^`]*`{1,3}/g, "")
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
    .replace(/!\[[^\]]*\]\([^)]+\)/g, "")
    .replace(/^[-*_]{3,}\s*$/gm, "")
    .replace(/^>\s+/gm, "")
    .replace(/^[-*+]\s+/gm, "")
    .replace(/^\d+\.\s+/gm, "")
    .replace(/\|/g, " ")
    .replace(/\n{2,}/g, ". ")
    .replace(/\n/g, " ")
    .replace(/\s{2,}/g, " ")
    .trim();

// ─── Voice availability hook ──────────────────────────────────────────────────
const useVoiceAvailability = () => {
  const [voiceMap, setVoiceMap] = useState({});
  const [ready, setReady]       = useState(false);

  const buildMap = useCallback(() => {
    const voices = window.speechSynthesis.getVoices();
    if (!voices.length) return;
    const map = {};
    for (const [lang, { lang: bcp }] of Object.entries(languageVoiceMap)) {
      const base = bcp.split("-")[0].toLowerCase();
      map[lang] = voices.some((v) => v.lang.toLowerCase().startsWith(base));
    }
    setVoiceMap(map);
    setReady(true);
  }, []);

  useEffect(() => {
    buildMap();
    window.speechSynthesis.onvoiceschanged = buildMap;
    let attempts = 0;
    const poll = setInterval(() => {
      if (window.speechSynthesis.getVoices().length > 0 || ++attempts > 40) {
        buildMap();
        clearInterval(poll);
      }
    }, 150);
    return () => {
      clearInterval(poll);
      window.speechSynthesis.onvoiceschanged = null;
    };
  }, [buildMap]);

  const isAvailable  = (lang) => !ready || voiceMap[lang] === true;
  const willFallback = (lang) => ready && voiceMap[lang] === false;

  return { isAvailable, willFallback, ready };
};

// ─── Core TTS — returns Promise<{ fellBack: boolean }> ────────────────────────
const speakText = (text, selectedLanguage, onEnd) => {
  window.speechSynthesis.cancel();
  const cleaned  = stripMarkdown(text);
  const { lang } = languageVoiceMap[selectedLanguage] || languageVoiceMap.english;
  const langBase = lang.split("-")[0].toLowerCase();

  return new Promise((resolve) => {
    const doSpeak = (voices) => {
      const matched =
        voices.find((v) => v.lang === lang) ||
        voices.find((v) => v.lang.toLowerCase().startsWith(langBase)) ||
        null;

      const fellBack = voices.length > 0 && !matched && selectedLanguage !== "english";

      const utterance   = new SpeechSynthesisUtterance(cleaned);
      utterance.rate    = 1.0;
      utterance.pitch   = 1.0;
      utterance.onend   = onEnd;
      utterance.onerror = onEnd;

      if (matched) {
        utterance.voice = matched;
        utterance.lang  = matched.lang;
      } else {
        utterance.lang = lang;
      }

      window.speechSynthesis.speak(utterance);
      resolve({ fellBack });
    };

    const attempt = () => {
      const voices = window.speechSynthesis.getVoices();
      if (voices.length > 0) {
        // 100 ms lets cancel() fully flush before the new utterance
        setTimeout(() => doSpeak(voices), 100);
        return;
      }
      let settled  = false;
      let attempts = 0;

      const finish = () => {
        if (settled) return;
        settled = true;
        window.speechSynthesis.onvoiceschanged = null;
        clearInterval(poll);
        doSpeak(window.speechSynthesis.getVoices());
      };

      window.speechSynthesis.onvoiceschanged = finish;
      const poll = setInterval(() => {
        if (window.speechSynthesis.getVoices().length > 0 || ++attempts > 30) finish();
      }, 100);
    };

    attempt();
  });
};

// ─── Voice fallback toast ─────────────────────────────────────────────────────
const VoiceFallbackToast = ({ language, onDismiss }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: 24 }}
    transition={{ type: "spring", stiffness: 320, damping: 28 }}
    className="fixed bottom-28 left-1/2 -translate-x-1/2 z-[300] flex items-start gap-3
               bg-white border border-amber-200 shadow-lg rounded-2xl px-5 py-3.5
               max-w-sm w-[90vw]"
  >
    <span className="text-amber-500 text-lg mt-0.5">⚠</span>
    <div className="flex-1 min-w-0">
      <p className="text-sm font-semibold text-gray-800 capitalize">
        {language} voice not available
      </p>
      <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">
        Your device doesn't have a{" "}
        <span className="font-medium capitalize">{language}</span> voice installed.
        Reading in English instead.
      </p>
    </div>
    <button
      onClick={onDismiss}
      className="text-gray-400 hover:text-gray-600 text-xl leading-none mt-0.5 flex-shrink-0"
    >
      ×
    </button>
  </motion.div>
);

// ─── Small reusable action button ─────────────────────────────────────────────
const ActionBtn = ({ onClick, disabled, children, title }) => (
  <motion.button
    title={title}
    whileHover={!disabled ? { backgroundColor: "#BDA697" } : {}}
    whileTap={!disabled ? { backgroundColor: "#7a6457" } : {}}
    onClick={!disabled ? onClick : undefined}
    className={`flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-medium shadow-sm transition-colors
      ${disabled ? "bg-gray-300 text-white cursor-not-allowed" : "bg-[#967d6c] text-white cursor-pointer"}`}
  >
    {children}
  </motion.button>
);

const IconPdf = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 7V3.5L18.5 9H13zM8 17v-2h8v2H8zm0-4v-2h8v2H8z" />
  </svg>
);

// ─── Disclaimer sections ──────────────────────────────────────────────────────
const disclaimerSections = [
  { heading: "Educational Purposes Only", body: "This analysis is provided for general educational and informational purposes only. It is not intended to constitute, and should not be relied upon as, veterinary medical advice, diagnosis, treatment, or a substitute for professional veterinary care." },
  { heading: "No Veterinary Relationship Formed", body: "No veterinarian-client-patient relationship (VCPR) is established through the use of this tool. A valid VCPR requires a licensed veterinarian to have sufficient knowledge of your animal through a physical, in-person examination and an ongoing relationship — neither of which this tool provides." },
  { heading: "Individual Animal Needs Vary", body: "All nutritional information, meal suggestions, supplement recommendations, and feeding guidance are general in nature. Individual animals have unique health profiles, medical histories, breed-specific needs, and conditions that may make general guidance inappropriate or unsafe. Always consult a licensed veterinarian or board-certified veterinary nutritionist (DACVN) before making changes to your pet's diet." },
  { heading: "Home-Prepared Meals", body: "Home-prepared meals can be a wholesome and healthy choice for your pet when done correctly. However, achieving complete and balanced nutrition at home requires careful planning. Without the right combination of ingredients and supplements, nutritional gaps can develop over time. Always work with a board-certified veterinary nutritionist to ensure any home-prepared diet fully meets your pet's individual needs." },
  { heading: "Ingredient Safety", body: "Ingredient safety information is provided for general guidance only. Individual animals may have allergies, intolerances, or conditions that make otherwise safe ingredients unsuitable for them. Toxic ingredient warnings reflect currently available knowledge and may not be exhaustive." },
  { heading: "Limitation of Liability", body: "Furbabies.AI expressly disclaims all liability for any adverse health outcomes, injury, illness, loss, or harm to any animal arising from reliance on the information provided. Use of this tool is entirely at your own risk." },
  { heading: "Medical Emergencies", body: "This tool is not intended for use in medical emergencies. If your pet is experiencing a medical emergency, contact your nearest emergency veterinary hospital immediately or call the ASPCA Animal Poison Control Center or the Pet Poison Helpline if poisoning is suspected." },
  { body: "By using Furbabies.AI, you acknowledge that you have read, understood, and agree to the terms of this disclaimer." },
];

// ─── Main component ───────────────────────────────────────────────────────────
const PetNutrition = () => {
  const [image, setImage]                         = useState(null);
  const [imageUploaded, setImageUploaded]         = useState(false);
  const [imagePreviewUrl, setImagePreviewUrl]     = useState("");
  const [analysis, setAnalysis]                   = useState("");
  const [animalType, setAnimalType]               = useState("dog");
  const [loading, setLoading]                     = useState(false);
  const [error, setError]                         = useState("");
  const [targetLanguage, setTargetLanguage]       = useState("english");
  const [question, setQuestion]                   = useState("");
  const [isImageExpanded, setIsImageExpanded]     = useState(false);
  const [isBotReplying, setIsBotReplying]         = useState(false);
  const [isChatOpen, setIsChatOpen]               = useState(false);
  const [isDisclaimerOpen, setIsDisclaimerOpen]   = useState(false);
  const [isSpeaking, setIsSpeaking]               = useState(false);
  const [isListening, setIsListening]             = useState(false);
  const [latestAnalysis, setLatestAnalysis]       = useState({ content: "" });
  const [referenceAnalysis, setReferenceAnalysis] = useState(false);

  // Voice availability state
  const { isAvailable, willFallback, ready }      = useVoiceAvailability();
  const [toast, setToast]                         = useState(null);

  // Print ref
  const mealReportRef = useRef(null);
  const handlePrintMeal = useReactToPrint({
    contentRef: mealReportRef,
    documentTitle: "Furbabies — Pet Nutrition Meal Report",
  });

  const [chatHistory, setChatHistory] = useState([
    {
      type: "answer",
      content: "Ask me anything about your pet's health, nutrition, or behavior — the more specific you are, the better I can help.\n\n**Disclaimer:** This chat is for general educational purposes only. It does not constitute veterinary medical advice, diagnosis, or treatment, and does not establish a veterinarian-client-patient relationship (VCPR). Never disregard or delay professional veterinary care based on anything discussed here. If your pet is experiencing a medical emergency, contact your nearest emergency veterinary hospital immediately or call the Animal Poison Control Center for suspected poisoning. Use of this chat is entirely at your own risk.",
    },
  ]);

  const { logout } = useAuth();
  const navigate   = useNavigate();
  const handleLogout = () => { logout(); navigate("/"); };

  // Stop speech on unmount / page leave
  useEffect(() => {
    const stop = () => { window.speechSynthesis.cancel(); setIsSpeaking(false); };
    window.addEventListener("beforeunload", stop);
    return () => window.removeEventListener("beforeunload", stop);
  }, []);

  // Clear conversation on page refresh
  useEffect(() => {
    if (window.performance && window.performance.navigation.type === 1) {
      const sessionId = localStorage.getItem("sessionId");
      axiosInstance.post("/clear_conversation", { sessionId }).catch(console.error);
    }
  }, []);

  // ── Upload handlers ───────────────────────────────────────────────────────
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    setImageUploaded(true);
    if (file) {
      setImage(file);
      setImagePreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleLanguageChange   = (e) => {
    setTargetLanguage(e.target.value);
    setToast(null); // dismiss any existing toast when language changes
  };
  const handleAnimalTypeChange = (e) => setAnimalType(e.target.value);

  // ── Submit handler ────────────────────────────────────────────────────────
  const handleSubmit = async () => {
    if (!image) { setError("Please upload an image."); return; }
    const formData  = new FormData();
    const sessionId = localStorage.getItem("sessionId");
    formData.append("image", image);
    formData.append("animal_type", animalType);
    formData.append("target_language", targetLanguage);
    setLoading(true);
    setError("");
    setAnalysis("");
    try {
      const response = await axiosInstance.post(`/analyze/${animalType}_food/`, formData, {
        headers: { "X-Session-ID": sessionId },
      });
      setIsImageExpanded(true);
      setAnalysis(response.data.analysis);
      setLatestAnalysis({ content: response.data.analysis });
    } catch (err) {
      setError(err.response?.data?.message || "Failed to analyze the image. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // ── Read aloud handler ────────────────────────────────────────────────────
  const handleToggleReadAloud = async () => {
    if (isSpeaking) {
      window.speechSynthesis.cancel();
      setIsSpeaking(false);
      return;
    }
    if (!analysis) return;
    setIsSpeaking(true);
    const { fellBack } = await speakText(analysis, targetLanguage, () => setIsSpeaking(false));
    if (fellBack) setToast({ language: targetLanguage });
  };

  // ── Chat handlers ─────────────────────────────────────────────────────────
  const handleQuestionChange = (e) => setQuestion(e.target.value);

  const handleAskQuestion = async (overrideText) => {
    const sessionId = localStorage.getItem("sessionId");
    const messageText = overrideText ?? question;
    if (messageText.trim() === "") return;
    setChatHistory((prev) => [...prev, { type: "question", content: messageText }]);
    setIsBotReplying(true);

    const analysisContext =
      referenceAnalysis && latestAnalysis.content
        ? `[Meal Analysis Context]\n${stripMarkdown(latestAnalysis.content)}`
        : "";

    try {
      const response = await axiosInstance.post("/ask", {
        question: messageText,
        target_language: targetLanguage,
        sessionId,
        ...(analysisContext && { analysis_context: analysisContext }),
      });
      if (response.data.type === "question_offer") {
        setChatHistory((prev) => [
          ...prev,
          { type: "answer", content: response.data.answer },
          { type: "question_offer" },
        ]);
      } else {
        setChatHistory((prev) => [...prev, { type: "answer", content: response.data.answer }]);
      }
    } catch {
      setChatHistory((prev) => [
        ...prev,
        { type: "answer", content: "An error occurred while fetching the answer." },
      ]);
    }
    setIsBotReplying(false);
    setQuestion("");
  };

  const sendDirectMessage = (text) => {
    handleAskQuestion(text);
  };

  const toggleChat = () => setIsChatOpen(!isChatOpen);

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <>
      {/* Hidden printable report target */}
      <div style={{ display: "none" }}>
        <PrintableReport ref={mealReportRef} title="Furbaby's Meal Plan" content={analysis} />
      </div>

      {/* Voice fallback toast */}
      <AnimatePresence>
        {toast && (
          <VoiceFallbackToast
            language={toast.language}
            onDismiss={() => setToast(null)}
          />
        )}
      </AnimatePresence>

      <div className="flex h-screen">
        <span className="block xl:hidden"><Navbarsmall /></span>

        {/* ── Sidebar ── */}
        <motion.nav className="fixed top-0 left-0 h-full w-1/8 md:w-1/8 bg-[#E8E1DA] space-y-8 z-50 xl:block hidden">
          <div className="text-4xl font-bold text-center text-gray-800">
            <a href="/" target="_blank" rel="noopener noreferrer">
              <img src={logo} alt="Logo" className="w-44 h-44 mx-auto" />
            </a>
          </div>
          <motion.ul className="text-[#967d6c] font-semibold">
            {[
              { to: "/furhome",       label: "Home"          },
              { to: "/pet-health",    label: "Pet Health"    },
              { to: "/pet-nutrition", label: "Pet Nutrition" },
            ].map(({ to, label }) => (
              <motion.li key={to} className="w-full">
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    isActive
                      ? "bg-[#967d6c] text-white w-full px-4 pt-3 pb-4 text-xl block"
                      : "hover:bg-[#bda697] w-full px-4 pt-3 pb-4 text-xl block"
                  }
                >
                  {label}
                </NavLink>
              </motion.li>
            ))}
          </motion.ul>
          <div className="absolute bottom-0 w-full pb-2">
            <button
              onClick={() => setIsDisclaimerOpen(true)}
              className="hover:bg-[#bda697] text-[#8b6145] w-full px-4 py-2 text-md bg-transparent focus:outline-none text-center block opacity-100 hover:opacity-100 transition-opacity"
            >
              Disclaimer
            </button>
            <NavLink
              to="#"
              onClick={handleLogout}
              className="hover:text-gray-800 poppins-text text-[#967d6c] w-full px-4 py-2 text-xl bg-transparent focus:outline-none text-center block"
            >
              Logout
            </NavLink>
          </div>
        </motion.nav>

        {/* ── Profile icon ── */}
        <div className="absolute top-20 xl:block hidden right-16 z-50">
          <Link to="/account">
            <motion.div
              className="text-5xl text-[#967d6c]"
              whileHover={{ scale: 1.2 }}
              transition={{ duration: 0.3 }}
            >
              <FaUserCircle />
            </motion.div>
          </Link>
        </div>

        {/* ── Main content ── */}
        <div className="flex-auto bg-white xl:mt-8 mt-24 p-8">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="text-5xl lg:text-[60px] lg:leading-[70px] mt-4 font-bold text-gray-800 mb-4">
              Hungry Furbaby?
            </h1>
            <p className="text-gray-600 poppins-text text-xl lg:text-[20px] lg:leading-[28px] mb-8">
              Take a picture of the food you have, and we will suggest a meal for your furbaby.
            </p>

            {/* ── Language + Animal selectors ── */}
            <div className="mb-8 flex flex-wrap gap-4 items-start">
              <div>
                <select
                  id="language"
                  value={targetLanguage}
                  onChange={handleLanguageChange}
                  className="block text-lg lg:text-[20px] poppins-text lg:leading-[26px] px-4 py-2 border border-[#BDA697] rounded-full"
                >
                  {ALL_LANGUAGES.map((l) => (
                    <option key={l} value={l}>
                      {l.charAt(0).toUpperCase() + l.slice(1)}
                      {ready && !isAvailable(l) ? " (read aloud: English fallback)" : ""}
                    </option>
                  ))}
                </select>

                {/* Inline warning — shown immediately when a no-voice language is selected */}
                <AnimatePresence>
                  {willFallback(targetLanguage) && (
                    <motion.p
                      key={targetLanguage}
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      className="text-amber-600 text-sm mt-2 flex items-center gap-1.5"
                    >
                      <span>⚠</span>
                      <span>
                        Your device has no{" "}
                        <span className="font-medium capitalize">{targetLanguage}</span>{" "}
                        voice installed — Read Aloud will play in English instead.
                      </span>
                    </motion.p>
                  )}
                </AnimatePresence>
              </div>

              <div>
                <select
                  id="animalType"
                  value={animalType}
                  onChange={handleAnimalTypeChange}
                  className="block text-xl lg:text-[20px] lg:leading-[26px] poppins-text px-4 py-2 border border-[#BDA697] rounded-full"
                >
                  <option value="dog">Dog</option>
                  <option value="cat">Cat</option>
                </select>
              </div>
            </div>

            {/* ── Upload + Submit ── */}
            <div className="flex space-x-4 mb-8">
              <label htmlFor="upload" className="cursor-pointer">
                <motion.span
                  whileHover={{ backgroundColor: "#BDA697" }}
                  whileTap={{ backgroundColor: "#967d6c" }}
                  className="inline-block bg-[#967d6c] text-white text-lg lg:text-[20px] lg:leading-[26px] lg:px-12 lg:py-4 px-6 py-2 rounded-full shadow-md"
                >
                  Upload a Photo
                </motion.span>
                <input
                  id="upload"
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageUpload}
                />
              </label>
              <motion.button
                onClick={handleSubmit}
                whileHover={imageUploaded && !loading ? { backgroundColor: "#BDA697" } : {}}
                whileTap={imageUploaded && !loading ? { backgroundColor: "#967d6c" } : {}}
                className={`lg:px-12 lg:py-4 px-6 py-2 text-lg lg:text-[20px] lg:leading-[26px] rounded-full shadow-md ${
                  loading || !imageUploaded
                    ? "bg-gray-400 text-white shadow-none"
                    : "bg-[#967d6c] text-white"
                }`}
              >
                {loading ? "Generating Meal..." : "Suggest Meal"}
              </motion.button>
            </div>

            {error && <p className="text-red-500 mt-4 poppins-text text-xl">{error}</p>}

            {imagePreviewUrl && (
              <div className="mt-8">
                <img
                  src={imagePreviewUrl}
                  alt="Uploaded Preview"
                  className="w-60 max-w-md h-auto object-contain rounded-lg"
                />
              </div>
            )}

            {loading && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="flex justify-center items-center mt-4"
              >
                <div className="w-8 h-8 border-4 border-b-transparent border-[#8B5E3C] rounded-full animate-spin" />
                <p className="text-[#8B5E3C] poppins-text ml-2">Generating Meal...</p>
              </motion.div>
            )}

            {/* ── Analysis result ── */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
              className="mt-8 pb-4"
            >
              <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
                <h2 className="text-3xl font-bold text-gray-800">Furbaby's Meal</h2>
                <div className="flex items-center gap-2 flex-wrap">
                  <ActionBtn
                    onClick={handleToggleReadAloud}
                    disabled={!analysis}
                    title="Read meal plan aloud"
                  >
                    {isSpeaking ? (
                      <>
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <rect x="6" y="4" width="4" height="16" rx="1" />
                          <rect x="14" y="4" width="4" height="16" rx="1" />
                        </svg>
                        Stop
                      </>
                    ) : (
                      <>
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
                        </svg>
                        Read Aloud
                      </>
                    )}
                  </ActionBtn>

                  <ActionBtn onClick={handlePrintMeal} disabled={!analysis} title="Save meal plan as PDF">
                    <IconPdf /> Save as PDF
                  </ActionBtn>

                  <Button
                    variant="outlined"
                    onClick={() => setIsImageExpanded(!isImageExpanded)}
                    style={{ backgroundColor: "#967d6c", color: "white" }}
                  >
                    {isImageExpanded ? "Minimize" : "Expand"}
                  </Button>
                </div>
              </div>

              <motion.div
                animate={{ height: isImageExpanded ? "calc(100vh - 400px)" : "300px" }}
                transition={{ duration: 0.3 }}
                className="w-full poppins-text text-lg p-4 mb-6 border border-gray-300 rounded-lg overflow-y-auto shadow-sm resize-none bg-white"
              >
                {analysis
                  ? <ReactMarkdown components={mdComponents}>{analysis}</ReactMarkdown>
                  : <span className="text-gray-400">We're here to help, just upload an image!</span>
                }
              </motion.div>
            </motion.div>
          </motion.div>
        </div>

        {/* ── Chat toggle button ── */}
        <div
          className="fixed bottom-5 right-5 bg-transparent cursor-pointer text-white rounded-full p-6 group"
          onClick={toggleChat}
        >
          <div className="absolute -left-[14rem] hidden xl:block top-1/2 -translate-y-1/2 bg-[#b89a8c] text-white text-md rounded-lg px-3 py-2 shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            Ask your personal Furbot!
          </div>
          <motion.div
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
            className="relative flex items-center bg-transparent justify-center w-16 h-16 rounded-lg"
          >
            <FaMessage className="w-20 h-20 text-[#e8e1da]" />
            <img src="../images/FurbotFilled.svg" alt="Furbot Icon" className="absolute bottom-5 w-10 h-10" />
          </motion.div>
        </div>

        {/* ── Chat panel ── */}
        {isChatOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            className="fixed bottom-36 right-5 bg-white border border-gray-200 rounded-2xl shadow-2xl w-[22rem] md:w-[32rem] flex flex-col"
            style={{ maxHeight: "75vh" }}
          >
            {/* Header */}
            <div className="p-4 bg-[#967d6c] text-white rounded-t-2xl flex items-center justify-between flex-shrink-0">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                  <img src="../images/Furbot.svg" alt="Furbot Icon" className="h-6 w-6 filter invert" />
                </div>
                <div>
                  <h3 className="text-xl font-bold leading-tight">Furbot</h3>
                  <p className="text-xs text-white/75">Your personal pet health assistant</p>
                </div>
              </div>
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={toggleChat}
                className="w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </motion.button>
            </div>

            {/* Reference analysis banner */}
            {latestAnalysis.content && (
              <div className="px-4 py-2.5 bg-[#f7f1eb] border-b border-[#e8ddd6] flex items-center justify-between flex-shrink-0">
                <div className="flex items-center gap-2">
                  <div className={`w-2 h-2 rounded-full ${referenceAnalysis ? "bg-green-500" : "bg-gray-300"}`} />
                  <span className="text-sm poppins-text text-gray-700 font-medium">
                    Reference my <span className="text-[#967d6c] font-semibold">meal analysis</span>
                  </span>
                </div>
                <button
                  onClick={() => setReferenceAnalysis((prev) => !prev)}
                  className={`relative inline-flex w-11 h-6 rounded-full transition-colors duration-200 focus:outline-none flex-shrink-0 ${referenceAnalysis ? "bg-[#967d6c]" : "bg-gray-300"}`}
                >
                  <span className={`inline-block w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200 mt-0.5 ${referenceAnalysis ? "translate-x-5" : "translate-x-0.5"}`} />
                </button>
              </div>
            )}

            {/* Messages */}
            <div className="flex-1 overflow-y-auto p-4 space-y-3 min-h-0">
              {chatHistory.map((msg, index) =>
                msg.type === "question_offer" ? (
                  <div key={index} className="flex gap-2 ml-10">
                    <button
                      onClick={() => sendDirectMessage("yes")}
                      disabled={isBotReplying}
                      className="px-4 py-1.5 rounded-full bg-[#967d6c] text-white text-sm font-semibold"
                    >
                      Yes, ask me
                    </button>
                    <button
                      onClick={() => sendDirectMessage("no")}
                      disabled={isBotReplying}
                      className="px-4 py-1.5 rounded-full border border-[#967d6c] text-[#967d6c] text-sm font-semibold"
                    >
                      Just answer
                    </button>
                  </div>
                ) : (
                  <div
                    key={index}
                    className={`flex items-start gap-2 ${msg.type === "question" ? "flex-row-reverse" : "flex-row"}`}
                  >
                    <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-white ${msg.type === "question" ? "bg-[#967d6c]" : "bg-[#bda697]"}`}>
                      {msg.type === "question"
                        ? "U"
                        : <img src="../images/Furbot.svg" alt="FB" className="h-4 w-4 filter invert" />
                      }
                    </div>
                    <div className={`max-w-[78%] px-3.5 py-2.5 rounded-2xl text-sm poppins-text leading-relaxed ${
                      msg.type === "question"
                        ? "bg-[#967d6c] text-white rounded-tr-sm"
                        : "bg-gray-100 text-gray-800 rounded-tl-sm"
                    }`}>
                      {msg.type === "question"
                        ? msg.content
                        : <ReactMarkdown components={chatMdComponents}>{msg.content}</ReactMarkdown>}
                    </div>
                  </div>
                )
              )}
              {isBotReplying && (
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-[#bda697] flex items-center justify-center flex-shrink-0">
                    <img src="../images/Furbot.svg" alt="FB" className="h-4 w-4 filter invert" />
                  </div>
                  <div className="bg-gray-100 px-4 py-3 rounded-2xl rounded-tl-sm flex items-center gap-1.5">
                    <span className="w-2 h-2 bg-[#967d6c] rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
                    <span className="w-2 h-2 bg-[#967d6c] rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
                    <span className="w-2 h-2 bg-[#967d6c] rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
                  </div>
                </div>
              )}
            </div>

            {/* Input */}
            <div className="p-3 border-t border-gray-100 flex-shrink-0 bg-white rounded-b-2xl">
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                multiline
                maxRows={3}
                value={question}
                onChange={handleQuestionChange}
                placeholder="Ask Furbot about your pet's meal…"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    backgroundColor: "#f7f1eb",
                    fontSize: "0.875rem",
                    "& fieldset": { borderColor: "#e0d4cc" },
                    "&:hover fieldset": { borderColor: "#967d6c" },
                    "&.Mui-focused fieldset": { borderColor: "#967d6c" },
                  },
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    handleAskQuestion();
                  }
                }}
              />
              <div className="mt-2">
                <button
                  onClick={() => handleAskQuestion()}
                  disabled={isBotReplying || question.trim() === ""}
                  className={`w-full py-2 rounded-xl text-white text-sm font-semibold transition-colors ${
                    isBotReplying || question.trim() === ""
                      ? "bg-gray-300 cursor-not-allowed"
                      : "bg-[#967d6c]"
                  }`}
                >
                  {isBotReplying ? "Sending..." : "Send"}
                </button>
              </div>
              {isListening && (
                <p className="text-xs text-[#967d6c] poppins-text mt-1.5 text-center animate-pulse">
                  🎙 Listening in {targetLanguage}…
                </p>
              )}
              {referenceAnalysis && latestAnalysis.content && (
                <p className="text-xs text-green-600 poppins-text mt-1 text-center">
                  ✓ Meal analysis will be sent as context
                </p>
              )}
            </div>
          </motion.div>
        )}
      </div>

      {/* ── Disclaimer modal ── */}
      <AnimatePresence>
        {isDisclaimerOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsDisclaimerOpen(false)}
              style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.4)", zIndex: 200 }}
            />
            <div style={{ position: "fixed", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 201, pointerEvents: "none" }}>
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.25 }}
                style={{ pointerEvents: "all" }}
                className="flex flex-col bg-[#F5F0EB] rounded-2xl shadow-2xl w-[min(90vw,640px)] max-h-[75vh]"
              >
                <div className="flex items-center justify-between px-7 py-5 border-b border-[#d4c4b8] shrink-0">
                  <h2 className="text-xl font-bold text-gray-800">Pet Nutrition Disclaimer</h2>
                  <button
                    onClick={() => setIsDisclaimerOpen(false)}
                    className="text-[#967d6c] hover:text-gray-800 transition-colors text-3xl leading-none font-light w-8 h-8 flex items-center justify-center"
                  >
                    ×
                  </button>
                </div>
                <div className="overflow-y-auto px-7 py-6 space-y-6 flex-1">
                  {disclaimerSections.map((section, i) => (
                    <div key={i} className="border-l-4 border-[#967d6c] pl-4">
                      {section.heading && (
                        <h3 className="font-bold text-gray-800 mb-1 text-sm">{section.heading}</h3>
                      )}
                      <p className="text-gray-600 text-sm leading-relaxed">{section.body}</p>
                    </div>
                  ))}
                </div>
                <div className="px-7 py-4 border-t border-[#d4c4b8] shrink-0">
                  <button
                    onClick={() => setIsDisclaimerOpen(false)}
                    className="w-full py-2 bg-[#967d6c] text-white font-semibold rounded-lg hover:bg-[#bda697] transition-colors text-sm"
                  >
                    I Understand
                  </button>
                </div>
              </motion.div>
            </div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default PetNutrition;